import axios from 'axios';

export const UPDATE_TEACHER_ROLE_REQUEST = 'UPDATE_TEACHER_ROLE_REQUEST';
export const UPDATE_TEACHER_ROLE_SUCCESS = 'UPDATE_TEACHER_ROLE_SUCCESS';
export const UPDATE_TEACHER_ROLE_FAILURE = 'UPDATE_TEACHER_ROLE_FAILURE';

export const updateTeacherRoles = (teacherId, roles, callback) => async (dispatch) => {
  dispatch({ type: UPDATE_TEACHER_ROLE_REQUEST });

  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/api/admin/sync-roles?teacherId=${teacherId}`, roles);
    dispatch({ type: UPDATE_TEACHER_ROLE_SUCCESS, payload: 'Roles updated successfully.' });
    if (callback) callback();
  } catch (error) {
    dispatch({
      type: UPDATE_TEACHER_ROLE_FAILURE,
      payload: error.response?.data || 'Failed to update teacher roles',
    });
  }
};
